<script>
import getBreadcrumbs from "./breadcrumbs";
import Breadcrumbs from "@/components/global/breadcrumbs.vue";
import AssignmentForm from "@/components/assignment/assignment_form.vue";

export default {
  name: "NewAssignmentView",

  components: {
    Breadcrumbs,
    AssignmentForm,
  },

  props: {
    isRedirectAfterCreated: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["input", "close"],

  data() {
    return {
      breadcrumbs: getBreadcrumbs("New assignment"),
    };
  },

  methods: {
    handleClose() {
      if (this.$listeners["close"]) {
        this.$emit("close");
      } else {
        this.$router.push("/assignments");
      }
    },
  },
};
</script>

<template>
  <eg-b-container>
    <section>
      <breadcrumbs :items="breadcrumbs" />
      <eg-b-row>
        <eg-b-col lg="6">
          <h1>{{ $t("common.newAssignment") }}</h1>
        </eg-b-col>
      </eg-b-row>
      <assignment-form
        :is-redirect-after-created="isRedirectAfterCreated"
        @input="$emit('input', $event)"
        @close="handleClose"
      />
    </section>
  </eg-b-container>
</template>
